import { queryFromTeams } from "@/modules/queryData";
import store from "@/store";
import { getTeamsDataFromUrl } from "../utils/utils";

export async function locateCommentFromNotification() {
    if (!queryFromTeams) return;
    const { annotData } = getTeamsDataFromUrl();
    if (!annotData) return;

    const pdfui = await store.viewer._getPDFUI();
    locateEvent(pdfui);
}

let sidebarCache = null;
function locateEvent(pdfui) {
    let goneToPage = false;
    async function locateHandler() {
        // 1. open comment sidebar.
        const sidebar = await pdfui.getComponentByName('comment-list-sidebar-panel');
        sidebar.active();
        sidebarCache = sidebar;
        const { annotData: { pageIndex, } } = getTeamsDataFromUrl();

        // 2. go to the page which contains this annot.
        if (pageIndex > 0 && !goneToPage) {
            goneToPage = true;
            await goToPage(pdfui, pageIndex);
        }
    }

    // When close loading, locate the comment.
    store.teamsAppStore.loading.onFinish(async () => {
        locateHandler();

        const { annotData: { pageIndex, } } = getTeamsDataFromUrl();
        const pdfUIStore = await pdfui.getStore();
        pdfUIStore.subscribe('update-comment-list-ex', (pages) => {
            // 3. current comment rendered, locate it.
            if (pages.find(p => p.page.info.index === pageIndex)) {
                locate();
            }
        });
        store.teamsAppStore.loading.hide();
    })

}

function locate() {
    const {
        annotData: {
            name: annotName,
            parentName: parentAnnotName,
            pageIndex,
        }
    } = getTeamsDataFromUrl();
    const rootName = parentAnnotName || annotName;
    // 1. find the comment which match the particular one.
    const commentList = sidebarCache.getComponentByName('commentlistEx');
    if (!commentList || commentList.controller.data.annotsGroup.length === 0) {
        return;
    }
    // 2. find the comment group which match the particular one.
    const commentGroup = commentList.children().find(it => it && it.pageNumber === pageIndex + 1);
    if (!commentGroup) {
        return;
    }
    commentGroup.active();
    // 3. find the comment component.
    let commentComponent = commentGroup.children().find(child => child.controller.data.annot.info.name === rootName);
    if (rootName !== annotName) {
        const i = commentComponent.controller.data.annot.replies.findIndex(annot => annot.info.name === annotName);
        commentComponent = commentComponent.children()[i];
    }
    if (!commentComponent) {
        return;
    }
    commentList.selectComponent(commentComponent);
    const scrollOptions = {
        block: 'nearest',
        behavior: 'smooth',
        inline: 'nearest'
    };
    commentComponent.element.scrollIntoView(scrollOptions);
}

async function goToPage(pdfui, pageIndex) {
    const viewer = await pdfui.getPDFViewer();
    const docRender = await viewer.getPDFDocRender();
    await docRender.goToPage(pageIndex, { x: 0, y: 0 });
    const curPage = await docRender.getCurrentPageIndex();
    if (curPage !== pageIndex) {
        await docRender.goToPage(pageIndex, { x: 0, y: 0 });
    }
    return;
}
